import {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';
import {useAbility} from '@casl/react';
import {Ability, AbilityBuilder} from '@casl/ability';

import {AbilityContext} from 'configs/CASLContext';

import {findUserInfo} from 'services/AuthService';
import {AuthSubject, DEFAULT_AVATAR_URL} from 'shared/constants/AppConst';
import {isEmptyObject} from 'utils/Utils';

export const useAuthUser = () => {
  const {keycloak, initialized} = useKeycloak();
  const intl = useIntl();
  const ability = useAbility(AbilityContext);

  const isLoading = !initialized;
  const isAuthenticated = keycloak.authenticated;
  const [user, setUser] = useState({});

  useEffect(() => {
    if (isAuthenticated && isEmptyObject(user)) {
      const headers = {
        Authorization: `Bearer ${keycloak?.token}`,
        'Accept-Language': intl.locale,
      };

      findUserInfo(headers).then((res) => {
        setUser({
          id: res.data?.id,
          username: res.data?.username,
          displayName: res.data?.fullName,
          email: res.data?.email,
          photoUrl: res.data?.photoUrl || DEFAULT_AVATAR_URL,
        });

        // authorities
        const authorities = res.data?.authorities || [];
        const {can, rules} = new AbilityBuilder(Ability);

        authorities.forEach((authority) => {
          const array = authority.split(/-(.+)/);
          let subject = '';
          switch (array[1]) {
            case 'USERS':
              subject = AuthSubject.User;
              break;
            case 'ROLES':
              subject = AuthSubject.Role;
              break;
            case 'SUBJECTS':
              subject = AuthSubject.Subject;
              break;
          }

          if (subject !== '') {
            can(String(array[0]).toLowerCase(), subject);
          }
        });

        ability.update(rules);
      });
    }
  }, [isAuthenticated]);

  return {
    isLoading,
    isAuthenticated,
    user,
  };
};

export const useAuthMethod = () => {
  const {keycloak} = useKeycloak();
  const logout = () => {
    return keycloak.logout();
  };
  return {logout};
};
